import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import Reviews from './components/Reviews';
import About from './components/About';
import Contact from './components/Contact';
import Privacy from './components/Privacy';
import Disclaimer from './components/Disclaimer';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Services />
      <HowItWorks />
      <Reviews />
      <Contact />
      <Privacy />
      <Disclaimer />
      <Footer />
    </div>
  );
}

export default App;
